import { Phone, ArrowRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="pt-24 pb-32 md:pb-16 border-t border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <Logo className="h-24 md:h-32 w-auto -ml-2" />
          <p className="mt-4 text-neutral-400 max-w-md">
            Custom golf simulators, direct-installed across Southern Alberta.
            Same tech. Half the price.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono-label text-[11px] text-neutral-500">Contact</p>
          <a
            href="tel:4033935772"
            data-testid="footer-phone"
            className="mt-3 flex items-center gap-2 text-[#F5F5F0] font-display font-bold text-2xl"
          >
            <Phone size={18} /> 403-393-5772
          </a>
          <p className="mt-3 text-neutral-500 text-sm">Text anytime.</p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono-label text-[11px] text-neutral-500">Site</p>
          <div className="mt-3 flex flex-col gap-2 text-sm">
            <a href="#sim-builder" className="text-neutral-300 hover:text-[#F5F5F0]">Sim Builder</a>
            <a href="#portfolio" className="text-neutral-300 hover:text-[#F5F5F0]">Portfolio</a>
            <a href="#quote-form" className="text-neutral-300 hover:text-[#F5F5F0]">Request Quote</a>
            <a href="/admin/login" className="text-neutral-600 hover:text-neutral-400 text-xs mt-3">Admin</a>
          </div>
        </div>
      </div>
      <div className="mt-16 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 flex flex-col md:flex-row justify-between gap-3 text-xs text-neutral-600 font-mono-label">
        <p>© {new Date().getFullYear()} The Sim Guys · Southern Alberta</p>
        <p>Builds start at $12,000 · Final quote given in person</p>
      </div>
    </footer>
  );
}
